// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'futuraPTProBook', 'futuraPTProBook Fallback'"},"className":"__className_851ad5","variable":"__variable_851ad5"};